import type { DocumentCollectionPortalPublishStatus } from "../../../api/types/documentCollectionTypes";
import DocumentCollectionPortalStatusTag from "./DocumentCollectionPortalStatusTag";

interface Props {
  isPublished: boolean | undefined;
}

const DocumentPortalStatusTag = ({ isPublished }: Props) => {
  // treat a missing value as published
  const portalPublishStatus: DocumentCollectionPortalPublishStatus =
    isPublished !== false ? "AllPublished" : "NonePublished";

  return <DocumentCollectionPortalStatusTag portalPublishStatus={portalPublishStatus} />;
};

export default DocumentPortalStatusTag;
